import React from 'react';

import { ReactFCV } from '@types';

import { StyledContainer } from '../../../../styled';

import { StyledWrapper, StyledTitle, StyledMessage } from './styled';

export const HeaderSkeleton: ReactFCV = () => (
  <StyledWrapper>
    <StyledContainer>
      <StyledTitle />
      <StyledMessage />
    </StyledContainer>
  </StyledWrapper>
);
